// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.
export const noPrice = '0.0';
export const priceFacetIds = [
	'internetPrice',
	'msrp',
	'retailValue',
	'invoicePrice'
];
export const fuelEfficiencyFacetIds = [
	'combinedFuelEfficiency',
	'highwayFuelEconomy',
	'cityFuelEconomy'
];
export const FACET_OVERRIDE_TYPE_SELECT = 'SELECT';
export const detailFacetLabels = ['rangeValue', ...fuelEfficiencyFacetIds];
